import { render } from "./Leads.vue?vue&type=template&id=603b962a&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=603b962a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603b962a"]])

export default __exports__